import {Formik} from 'formik';

import {FormComponent} from './FormComponent';

import {RecordSchema} from './RecordSchema';

import {FormWithButtons} from '@flexinet/ui-components';

import {DomainName} from '../types';
import {useNavigate} from "react-router-dom";
import {stage} from "../../../config/stage";

export const RecordForm = ({
                               record,
                               handleSubmit,
                           }: {
    // Optional: the Add page has no record yet (FNP-942 — React Query types
    // the absent record honestly; the body already guards with `if (record)`).
    record?: Omit<DomainName, 'id'>,
    // Returns a promise so the form can WAIT for the server. A void-returning
    // handler is what made `isSubmitting` inert.
    handleSubmit: (values: DomainName) => void | Promise<unknown>
}) => {
    const navigate = useNavigate()

    // FNP-1282: async and AWAITED. Navigating on the same tick routed the
    // operator off the form before the server answered, so a rejection landed on
    // a page that could no longer show it — and Formik cleared `isSubmitting`
    // immediately, leaving the spinner wiring permanently inert.
    const onSubmit = async (values: DomainName) => {
        await handleSubmit(values);
        navigate('/domain-names');
    };

    const onCancel = () => {
        navigate('/domain-names');
    };


    let initialValues = {} as DomainName;

    if (record) {
        initialValues = Object.assign({}, initialValues, record);
    }

    return (
        <Formik
            initialValues={initialValues}
            validationSchema={RecordSchema}
            onSubmit={onSubmit}
        >
            {({
                  handleSubmit,
                  isSubmitting,
                  ...rest
              }) => (
                <FormWithButtons handleSubmit={handleSubmit} isSubmitting={isSubmitting}
                                 handleCancel={onCancel} debug={false && stage === 'ide'} {...rest}  >
                    <FormComponent/>
                </FormWithButtons>)}
        </Formik>
    );
};
